import { injectable } from "inversify";
import * as toml from 'toml';
import * as fs from 'fs';

export interface ServiceConfiguration {

    /**
     * retrun the configuration for the profile DEFAULT
     */
    getConfiguration(): Configuration;

    save(config: Configuration, profile: string, force: boolean ): Promise<boolean>;

    isConfigurationPersisted(): boolean;
}

interface ConfigObj {
    audience?: string;
    username: string;
    password: string;
}

export class Configuration {

    readonly audience?: string;
    readonly username: string;
    readonly password: string;

    constructor(obj: ConfigObj) {
        this.audience = obj.audience;
        this.username = obj.username;
        this.password = obj.password;
    }
}

@injectable()
export class ServiceConfigurationToml implements ServiceConfiguration {

    private config: Configuration;
    private readonly configDir = `${require('os').homedir()}/.porcli`;
    private readonly configCredentialsFile = `${this.configDir}/credentials`;

    constructor() {
        // Configuration is initialized lazily. Some services (user/config) do not require configuration; actually they create it!

    }

    private initFromFile(): Configuration {

        try {
            const configFile = fs.readFileSync(this.configCredentialsFile, 'utf8');
            const data = toml.parse(configFile);
    
            return new Configuration({
                audience: "https://kotenna.porketta.eu",
                password: data['default'].password,
                username: data['default'].username,
            });
        }
        catch (e) {
            if (e.code === 'ENOENT') {
                throw new Error("Please login running 'porcli user login' before run any other command.");
            } 
            throw e;
        }

    }

    getConfiguration(): Configuration {
        if(!this.config) {
            this.config = this.initFromFile();
        }

        return this.config;
    }

    isConfigurationPersisted(): boolean {
        return fs.existsSync(this.configCredentialsFile);
    }

    public async save(config: Configuration, profile: string, force: boolean): Promise<boolean> {

        if(this.isConfigurationPersisted() && !force) {
            return Promise.reject(new Error("Configuration file already exists!"));
        }

        if (!fs.existsSync(this.configDir)) {
            fs.mkdirSync(this.configDir);
        }


        fs.writeFileSync(this.configCredentialsFile, `[${profile}]\n`, {encoding: 'utf8', flag: 'w'}); // Create/clear
        fs.writeFileSync(this.configCredentialsFile, `username="${config.username}"\n`, {encoding: 'utf8', flag: 'a'});
        fs.writeFileSync(this.configCredentialsFile, `password="${config.password}"\n`, {encoding: 'utf8', flag: 'a'});

        return Promise.resolve(true);
    }



}